interface Filter {
  selected: string;
  url: string;
  removeUrl: string;
  name: string;
  id: string;
}
interface FilterGropu extends Filter {
  children: Filter[];
}
interface Group {
  [key: string]: FilterGropu;
}

const filterGrouping = {
  parentIds: [
    '101',
    '689',
    '102',
    '316',
    '1237',
    '1148',
    '447',
    '649',
    '61',
    '104',
    '1368',
    '1241',
    '1259',
    '1552',
    '317',
    '334',
    '573',
    '635',
  ],
  filters: (window as any).filter as Filter[],
  grouped: {} as any,
  deskFilterHtml: document.getElementById('deskCatFilter') as
    | HTMLElement
    | undefined,
  mobCatFilter: document.getElementById('mobCatFilter') as
    | HTMLElement
    | undefined,
  mobCatSubFilter: document.getElementById('mobCatSubFilter') as
    | HTMLElement
    | undefined,
  deskSubCatFilter: document.getElementById('deskSubCatFilter') as
    | HTMLElement
    | undefined,
  init() {
    if (!this.deskSubCatFilter || !this.mobCatSubFilter) return;
    this.gropuItems();
    this.createHtml();
  },
  gropuItems() {
    let currentParent = '';
    this.grouped = this.filters.reduce((acc, item) => {
      if (this.parentIds.includes(item.id)) {
        currentParent = item.id;
        acc[currentParent] = { ...item, children: [] };
      } else {
        acc[currentParent]?.children.push(item);
      }
      return acc;
    }, {});
  },
  createHtml() {
    // let deskCatHtml = '';
    let deskSubCatHtml = '';
//     let mobCatHtml = `<li class="menu-nav__item">                                
//     <div  class="menu-nav__link menu-nav__link--back jsBack">
//         <svg >
//             <use xlink:href="#chevron-left-solid"></use>
//         </svg>
//         <span>FILTER BY CATEGORY</span>
//     </div>								
// </li> `;
    let mobSubCatHtml = `<li class="menu-nav__item">                                
<div  class="menu-nav__link menu-nav__link--back jsBack">
    <svg >
        <use xlink:href="#chevron-left-solid"></use>
    </svg>
    <span>FILTER BY SUBCATEGORY</span>
</div>								
</li> `;
    Object.values(this.grouped).forEach((item) => {
      const el = item as FilterGropu;
      // deskCatHtml += this.createItem(el);
      deskSubCatHtml += this.crearteCategoryAccordian(el);
      // mobCatHtml += this.createMobItem(el);
      mobSubCatHtml += this.crearteSlide(el);      
    });
    // this.mobCatFilter!.innerHTML = mobCatHtml;
    this.mobCatSubFilter!.innerHTML = mobSubCatHtml;
    // this.deskFilterHtml!.innerHTML = deskCatHtml;
    this.deskSubCatFilter!.innerHTML = deskSubCatHtml;
  },
  crearteSlide(item: FilterGropu): string {
    return `
    <li class="menu-nav__item " > 
            <div  class="menu-nav__link  jsNextLvl">                        
                <span>${item.name}</span>
                <svg >
                    <use xlink:href="#chevron-right-solid"></use>
                </svg>
            </div>	

            <div class="main-nav__dropdown ">
                <ul class="main-nav__lvl1__menu ">      
                    <li class="menu-nav__item">                                
                        <div  class="menu-nav__link menu-nav__link--back jsBack">
                            <svg >
                                <use xlink:href="#chevron-left-solid"></use>
                            </svg>
                            <span>${item.name}</span>
                        </div>								
                    </li>                    
                    ${item.children.reduce((acc, item) => {
                      const el = item as Filter;
                      return (acc += this.createMobItem(el));
                    }, '')}
                </ul>
            </div>
        </li>   
       `;
  },
  crearteCategoryAccordian(item: FilterGropu): string {
    const selected = item.children.some((item) => item.selected === '1');
    return `<div class="filter-desk__acc"> 
       <div class="filter-desk__acc-item  jsAccordianItem" data-open="${
         selected ? 'true' : 'false'
       }"        >
           <div class="filter-desk__item">  
               <span>${item.name}</span>
           </div>
           <svg class="filter-desk__minus">
               <use xlink:href="#minus-regular"></use>
           </svg>
           <svg class="filter-desk__plus">
               <use xlink:href="#plus-regular"></use>
           </svg>
       </div>
       <ul class="filter-desk__grid">
           ${item.children.reduce((acc, item) => {
             const el = item as Filter;
             return (acc += this.createItem(el));
           }, '')}
       
       </ul>
       </div>   
       `;
  },

  createItem(item: Filter) {
    if (item.selected === '1') {
      return `                  
        <a  href="${item.removeUrl}" class="filter-desk__item">
            <svg >
                <use xlink:href="#square-check-regular"></use>
            </svg>
            <span>${item.name}</span>  
        </a>  `;
    } else {
      return `                  
        <a  href="${item.url}" class="filter-desk__item">
        <svg>
        <use xlink:href="#square-regular"></use>
    </svg>
            <span>${item.name}</span>  
        </a>  `;
    }
  },
  createMobItem(item: Filter) {
    if (item.selected === '1') {
      return `<li>          
                <a  href="${item.removeUrl}" class="filter-desk__item">
                    <svg >
                        <use xlink:href="#square-check-regular"></use>
                    </svg>
                    <span>${item.name}</span>  
                </a>  
            </li>`;
    } else {
      return `                  
      <li>
      <a  href="${item.url}" class="filter-desk__item" >                          
          <svg>
              <use xlink:href="#square-regular"></use>
          </svg>
          <span class="filter-desk__item-text">${item.name}</span>
      </a>
  </li> `;
    }
  },
};

export default filterGrouping;
